import Dialog from '@/components/Dialog';
import { type LevelProgressNote } from '@/lib/types';
import { useContext, useState } from 'react';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import useApi from '@/lib/api/useApi';
import { Delete as DeleteIcon } from '@mui/icons-material';
import useRubricsPortfolioApiEndpoint from '../../../../useRubricsPortfolioApiEndpoint';
import { FormattedMessage } from 'react-intl';
import { IconButton } from '@mui/material';

type DeleteLevelProgressNoteProps = {
  levelProgressNote: LevelProgressNote;
};

const DeleteLevelProgressNote = ({
  levelProgressNote,
}: DeleteLevelProgressNoteProps) => {
  const api = useApi();
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const [, setPortfolio] = useContext(RubricsPortfolioContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteNote = async (): Promise<void> => {
    setConfirmationDialogOpen(false);
    setDeleting(true);

    await api.delete(
      `${rubricsPortfolioApiEndpoint}/level-progress-notes/${levelProgressNote.id}`,
    );

    setPortfolio(portfolio => {
      delete portfolio.levelProgressNotes![levelProgressNote.levelId][
        levelProgressNote.id
      ];
    });

    setDeleting(false);
  };

  return (
    <>
      <IconButton
        edge="end"
        size="small"
        color="error"
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.level.attachments.level_progress_notes.note.delete.dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio.level.attachments.level_progress_notes.note.delete.dialog.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteNote} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteLevelProgressNote;
